import React, { useState, useEffect, FormEvent, ChangeEvent } from 'react';
import { useNavigate } from "react-router-dom";

import secureLocalStorage from "react-secure-storage";

import { IMAGES } from '../utils/images';

import UserService from '../services/user.service';

import './login.css';
import { useAuth } from '../AuthProvider';

const CreateAccount: React.FC = () => {
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [repassword, setRePassword] = useState("");

    const { setLoggedInUser } = useAuth();

    const navigate = useNavigate();

    useEffect(() => {
        secureLocalStorage.removeItem('user');
    }, []);

    async function create(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        
        // Validation
        if (username === "" || email === "" || password === "") {
            alert("Please fill in all required fields");
            return;
        }

        if (password !== repassword) {
            alert("Passwords do not match");
            return;
        }

        if (password.length < 6) {
            alert("Password must be at least 6 characters");
            return;
        }

        const data = {
            email: email,
            username: username,
            password: password,
        };

        try {
            // Register the user account (automatically logs in and stores token)
            const response = await UserService.register(data);
            setLoggedInUser(response.data.user);
            navigate("/home");
        } catch (error: any) {
            if (error.response) {
                if (error.response.status === 409) {
                    alert("Email or username already exists!");
                } else if (error.response.status === 400) {
                    alert(error.response.data?.message || "Please fill in all required fields");
                } else {
                    alert("Failed to create account");
                    console.log("Error: ", error);
                }
            } else {
                alert("Failed to create account");
                console.log("Error: ", error);
            }
        }
    }

    return (
        <div className="login_page" style={{ backgroundImage: `url(${IMAGES.backgrounds.room})` }}>
            <img src={IMAGES.logo} className="logo" alt="Logo" />
            <div className="login_container">
                <p className="login_text">Create Account</p>
                <form className="form_container" onSubmit={create}>
                    <input
                        type="email"
                        placeholder='Email...'
                        value={email}
                        className="form_option"
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder='Username...'
                        value={username}
                        className="form_option"
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder='Password...'
                        value={password}
                        className="form_option"
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder='Re-type Password...'
                        value={repassword}
                        className="form_option"
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setRePassword(e.target.value)}
                    />
                    <button type="submit" className="button_std submit_button">
                        Submit
                    </button>
                </form>
                <p className='link' onClick={() => navigate('/login')}>Already have an account? Login!</p>
                <p className='link' onClick={() => navigate("/home")}>Continue as Guest</p>
            </div>
        </div>
    );
};

export default CreateAccount;

